var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 277.60223,
    height: 500,
    viewBox: "0 0 73.448915 132.29166",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(2.5329539e-6,-164.70825)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D3 \\uE1E7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26515198px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 27.0948143
    },
    id: "text4119",
    transform: "matrix(1.3480391,0,0,1.3480391,8.8157377e-7,-57.324901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4123",
    style: {
      strokeWidth: 27.0948143
    },
    d: "m 54.48575,248.89385 c 0,-2.64584 -2.164773,-4.81061 -4.810606,-4.81061 -2.645834,0 -4.810606,2.16477 -4.810606,4.81061 0,2.64583 2.164772,4.8106 4.810606,4.8106 2.645833,0 4.810606,-2.16477 4.810606,-4.8106 z m -43.661889,13.95076 c 18.280303,0 22.008523,-14.79262 22.008523,-18.52084 V 164.70824 H 29.94602 v 72.88068 c -1.924242,-1.68371 -4.690341,-2.64583 -8.057765,-2.64583 -16.716856,0 -21.8882575329589,12.86837 -21.8882575329589,18.6411 0,5.89299 4.6903409329589,9.26042 10.8238635329589,9.26042 z m 2.525568,-19.0019 c 5.532197,-3.12689 9.019887,-4.32954 11.304925,-4.32954 2.044507,0 3.247159,0.96212 3.96875,2.4053 0.48106,0.60132 0.721591,1.32292 0.721591,2.04451 0,2.28503 -2.285038,4.93087 -10.102273,9.982 -5.051137,3.36743 -8.418561,4.57008 -10.8238639,4.57008 -2.405303,0 -3.7282197,-1.20265 -4.4498106,-2.52557 -0.3607955,-0.60132 -0.7215909,-1.44318 -0.7215909,-2.16477 0,-2.4053 2.405303,-5.5322 10.1022724,-9.98201 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChd);
export default __webpack_public_path__ + "static/media/chd.ed3ebb8e9a96d9bbbbf12b15cace5e8d.svg";
export { ForwardRef as ReactComponent };